import React from 'react';
import './Hero.css';

const Hero = () => {
  const handleGetStarted = () => {
    // This will be updated when we add routing
    window.location.hash = '#converter';
  };

  return (
    <section className="hero">
      <div className="landing-container-full">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Complete PDF Toolkit
              <span className="gradient-text"> for Every Need</span>
            </h1>
            <p className="hero-description">
              Professional PDF tools that work entirely in your browser. Convert files to PDF or edit existing PDFs with precision.
              <strong>100% free</strong> - no uploads, no registration, complete privacy guaranteed.
            </p>

            <div className="hero-buttons">
              <button className="btn btn-primary btn-large" onClick={handleGetStarted}>
                📄 Convert to PDF
                <svg width="20" height="20" viewBox="0 0 20 20" className="btn-icon">
                  <path d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" fill="currentColor"/>
                </svg>
              </button>
              <button
                className="btn btn-secondary btn-large"
                onClick={() => window.location.hash = '#page-remover'}
              >
                🗑️ Remove Pages
                <svg width="20" height="20" viewBox="0 0 20 20" className="btn-icon">
                  <path d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" fill="currentColor"/>
                </svg>
              </button>
            </div>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">15+</span>
                <span className="stat-label">File Formats</span>
              </div>
              <div className="stat">
                <span className="stat-number">Fast</span>
                <span className="stat-label">Processing</span>
              </div>
              <div className="stat">
                <span className="stat-number">Free</span>
                <span className="stat-label">to Use</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-card">
              <div className="card-header">
                <div className="file-icon">
                  <svg width="48" height="48" viewBox="0 0 48 48">
                    <defs>
                      <linearGradient id="fileGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#4facfe" />
                        <stop offset="100%" stopColor="#00f2fe" />
                      </linearGradient>
                    </defs>
                    <rect x="8" y="6" width="24" height="32" rx="2" fill="url(#fileGradient)" />
                    <path d="M32 14l-6-6v6h6z" fill="white" fillOpacity="0.8" />
                    <rect x="12" y="18" width="16" height="2" fill="white" fillOpacity="0.6" />
                    <rect x="12" y="22" width="16" height="2" fill="white" fillOpacity="0.6" />
                    <rect x="12" y="26" width="12" height="2" fill="white" fillOpacity="0.6" />
                  </svg>
                </div>
                <div className="conversion-arrow">
                  <svg width="32" height="32" viewBox="0 0 32 32">
                    <path d="M20 12l4 4-4 4M8 16h12" stroke="#667eea" strokeWidth="2" fill="none" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className="pdf-icon">
                  <svg width="48" height="48" viewBox="0 0 48 48">
                    <rect x="8" y="6" width="24" height="32" rx="2" fill="#dc2626" />
                    <text x="20" y="24" textAnchor="middle" fill="white" fontSize="8" fontWeight="bold">PDF</text>
                  </svg>
                </div>
              </div>
              <div className="supported-formats">
                <span className="format">DOC</span>
                <span className="format">DOCX</span>
                <span className="format">JPG</span>
                <span className="format">PNG</span>
                <span className="format">TXT</span>
                <span className="format">HTML</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-bg">
        <div className="floating-element element-1"></div>
        <div className="floating-element element-2"></div>
        <div className="floating-element element-3"></div>
      </div>
    </section>
  );
};

export default Hero;